<template>
  <el-dialog
    title="控销品咨询电话"
    :visible.sync="visible"
    width="420px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="handleClose"
  >
    <el-form :model="form" label-width="100px" :rules="rules" ref="form">
      <el-form-item label="">
        <span>仅作业务员咨询多控销品的咨询电话</span>
      </el-form-item>
      <el-form-item label="咨询电话" prop="phoneNum">
        <el-input
          v-model="form.phoneNum"
          placeholder="请输入咨询电话"
          style="width: 220px"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "MutilCtrPhoneSettingDialog",
  data() {
    return {
      visible: false,
      form: {
        phoneNum: "",
      },
      rules: {
        phoneNum: [
          { required: true, message: "请输入咨询电话", trigger: "blur" },
          // 只检验有没有输入，不检验是否正确
          // {
          //   pattern: /^1[3456789]\d{9}$/,
          //   message: "请输入正确的咨询电话",
          //   trigger: "change",
          // },
        ],
      },
    };
  },
  methods: {
    publicOpen(phone) {
      this.form.phoneNum = phone;
      this.visible = true;
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.form);
          this.visible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.form.phoneNum = "";
    },
  },
};
</script>
<style scoped lang="scss"></style>
